import React, { useState, useEffect } from 'react';

export default function LiveClock() {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const timeStr = now.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
  });
  const dateStr = now.toLocaleDateString('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });

  return (
    <div className="live-clock" title="Current clinic time">
      <span className="live-clock-dot" />
      <div>
        <div className="live-clock-time">{timeStr}</div>
        <div className="live-clock-date">{dateStr}</div>
      </div>
    </div>
  );
}
